import React from "react";

const Walk = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="30"
    viewBox="0 0 9 15.162"
  >
    <path
      id="Icon_awesome-walking"
      data-name="Icon awesome-walking"
      d="M6.16,2.843A1.421,1.421,0,1,0,4.739,1.421,1.422,1.422,0,0,0,6.16,2.843Zm2.8,4.415-.69-.349-.287-.871A3.228,3.228,0,0,0,4.955,3.79a6.511,6.511,0,0,0-2.763.746A2.824,2.824,0,0,0,.721,5.9l-.2.4a.951.951,0,0,0,.42,1.27A.935.935,0,0,0,2.2,7.154l.2-.4A.941.941,0,0,1,2.888,6.3l.794-.32-.45,1.8a1.9,1.9,0,0,0,.441,1.741L5.446,11.45a1.911,1.911,0,0,1,.441.82l.542,2.17a.948.948,0,1,0,1.839-.459l-.657-2.635a1.894,1.894,0,0,0-.441-.82L5.822,9.055,6.332,7.02l.163.489a1.888,1.888,0,0,0,.939,1.1l.69.349a.935.935,0,0,0,1.258-.423.959.959,0,0,0-.423-1.273ZM2.18,11.423a1.837,1.837,0,0,1-.42.637L.279,13.544a.947.947,0,0,0,1.338,1.341l1.759-1.759a1.925,1.925,0,0,0,.42-.637l.4-1C2.559,9.7,3.051,10.251,2.793,9.9L2.18,11.423Z"
    />
  </svg>
);

export default Walk;
